import { isNil } from "@fxts/core"

import { formatTaxRegistrationId } from "@/utils/format"

export const isEqualsTaxRegistrationId = (a: string, b: string) => {
  if (isNil(a) && isNil(b)) {
    return false
  }

  if (a === "" && b === "") {
    return false
  }

  const aValue = formatTaxRegistrationId(a)
  const bValue = formatTaxRegistrationId(b)
  return aValue === bValue
}
